import React, { FC, ReactNode } from "react";
import { View, Text } from "@tarojs/components";
import classNames from "classnames";
import { navigateBack, getSystemInfoSync } from "@tarojs/taro";
import useCustomNavBar from "@/hooks/useCustomNavbar";

import { XHComponentCommonProps } from "../../types";
import "./index.scss";

export type NavBarProps = {
  title: string;
  leftIcon?: boolean;
  rightIcon?: ReactNode;
  navBarBorder?: boolean;
  onBack?: () => void;
} & XHComponentCommonProps;

// 小程序中判断设备系统
const isMiniProgramIos =
  process.env.TARO_ENV !== "h5"
    ? getSystemInfoSync().platform === "ios"
    : false;
const NavBar: FC<NavBarProps> = props => {
  const {
    leftIcon = true,
    rightIcon = false,
    title,
    onBack,
    navBarBorder = false,
    className,
  } = props;

  const { navBarHeight, statusBar, buttonRight } = useCustomNavBar();

  function goBackPage() {
    onBack ? onBack() : navigateBack();
  }

  const wrapStyle =
    process.env.TARO_ENV === "h5"
      ? {}
      : {
          height: `${navBarHeight}px`,
          paddingTop: `${statusBar}px`,
        };

  const backStyle =
    process.env.TARO_ENV === "h5"
      ? {}
      : {
          left: `${buttonRight}px`,
        };

  const NavBarCls = classNames("xh-nav-bar", className, {
    h5: process.env.TARO_ENV === "h5",
    border: navBarBorder,
  });

  return (
    <View className={NavBarCls} style={wrapStyle}>
      <View
        className={classNames("xh-nav-bar-back", { hidden: !leftIcon })}
        style={backStyle}
        onClick={goBackPage}
        // @ts-ignore
        dataTrackId="NavBar_Back"
      ></View>
      <Text
        className={classNames("xh-nav-bar-title", {
          isAndroid: !isMiniProgramIos,
        })}
      >
        {title}
      </Text>
      {process.env.TARO_ENV === "h5" && rightIcon && (
        <View className="xh-nav-bar-right">{rightIcon}</View>
      )}
      <View />
    </View>
  );
};

export default NavBar;
